// macadamia-app/src/macadamia-core/components/widgets/composite-text-widget/Toolbar.tsx
import React from 'react';
import LinkManagement from './LinkManagement';
import AnnotationManagement from './AnnotationManagement';
import Bold from './../../../icons/Bold';
import Italic from './../../../icons/Italic';
import Underline from './../../../icons/Underline';

interface ToolbarProps {
  onFormat: (command: string, value?: string) => void;
  onAddEntity: (type: string, data: any) => void;
  setForceToolbarVisible: (isVisible: boolean) => void;
  mode: 'editor' | 'reader';
  onOpenJurisprudenceModal: () => void;
  onOpenLegifranceModal: () => void;
  onOpenHALModal: () => void;
}

const Toolbar: React.FC<ToolbarProps> = ({ onFormat, onAddEntity, mode, setForceToolbarVisible, onOpenJurisprudenceModal, onOpenLegifranceModal, onOpenHALModal }) => {
  if (mode !== 'editor') return null;

  const handleAddLink = (url: string) => {
    const selection = window.getSelection();
    const text = selection ? selection.toString() : '';

    onAddEntity('link', { url, text: text || url });
  };

  return (
    <div className="bg-white border border-gray-300 rounded-lg shadow-lg shadow-inner pt-1 pl-1 pr-1 pb-1 flex space-x-0 relative">
      <button onClick={() => onFormat('bold')} className="p-1 hover:bg-mcdm-primary-200 rounded text-mcdm-third-500">
        <Bold width="23px" height="23px" stroke="currentColor" />
      </button>
      <button onClick={() => onFormat('italic')} className="p-1 hover:bg-mcdm-primary-200 rounded text-mcdm-third-500">
        <Italic width="23px" height="23px" stroke="currentColor" />
      </button>
      <button onClick={() => onFormat('underline')} className="p-1 hover:bg-mcdm-primary-200 rounded text-mcdm-third-500">
        <Underline width="23px" height="23px" stroke="currentColor" />
      </button>

      <LinkManagement onAddLink={handleAddLink} setForceToolbarVisible={setForceToolbarVisible} />

      <AnnotationManagement
        onAddAnnotation={(content) => onAddEntity('annotation', { content })}
        setForceToolbarVisible={setForceToolbarVisible}
      />

      <button onClick={onOpenJurisprudenceModal} className="px-2 py-1 hover:bg-mcdm-primary-200 rounded text-mcdm-third-500 text-sm">
        Jurisprudence
      </button>
      <button onClick={onOpenLegifranceModal} className="px-2 py-1 hover:bg-mcdm-primary-200 rounded text-mcdm-third-500 text-sm">
        Légifrance
      </button>
      <button onClick={onOpenHALModal} className="px-2 py-1 hover:bg-mcdm-primary-200 rounded text-mcdm-third-500 text-sm">
        HAL
      </button>
    </div>
  );
};

export default Toolbar;
